import baseAPI from './axiosApi'

const api={
    get: '/api-u/roles/',
    getnopage: '/api-u/roles/all',
    roleaddusers: '/api-u/roles/'
}
//获取角色已选菜单
export function queryRolePermission (id) {
    return baseAPI.axiosData(api.get+id+'/menus','get')
}
//保存角色菜单
export function saveRolePermission (id,parameter) {
    return baseAPI.axiosData(api.get+id+'/menus','post',parameter)
}
//获取角色下拉框
export function getRoleSelect () {
    return baseAPI.axiosData(api.getnopage,'get')
}
//获取添加用户
export function roleAddUsers (roleId, parameter) {
    return baseAPI.axiosData(api.roleaddusers+roleId+'/users','post', parameter)
}